// extracted by mini-css-extract-plugin
export default {"inputContainer":"InviteCustomerForm_inputContainer__Tci5D","input":"InviteCustomerForm_input__2P+vR","button":"InviteCustomerForm_button__v79jv"};